import { render } from "./HelpFS.vue?vue&type=template&id=2f9182e6&scoped=true"
const script = {}

import "./HelpFS.vue?vue&type=style&index=0&id=2f9182e6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9182e6"]])

export default __exports__